import React from 'react';
import { Star, ShieldCheck, Zap, BookOpen } from 'lucide-react';
import { Button } from './ui/Button';
export function Hero() {
  return <section className="relative pt-12 pb-20 px-4 overflow-hidden" data-id="element-45">
      <div className="absolute top-1/4 left-1/2 -translate-x-1/2 w-[600px] h-[600px] bg-brand-pink/20 rounded-full blur-[120px] -z-10 pointer-events-none" data-id="element-46"></div>

      <div className="max-w-5xl mx-auto text-center" data-id="element-47">
        <div className="inline-flex items-center gap-2 bg-zinc-900 border border-zinc-800 rounded-full px-4 py-2 mb-6 animate-fade-in" data-id="element-48">
          <span className="flex h-2 w-2 rounded-full bg-brand-pink animate-pulse" data-id="element-49"></span>
          <span className="text-xs md:text-sm font-medium text-zinc-300 uppercase tracking-wider" data-id="element-50">
            Fútbol Femenino Elite System
          </span>
        </div>

        <h1 className="text-3xl md:text-5xl lg:text-6xl font-black text-white leading-[1.05] mb-6 text-balance uppercase tracking-tight" data-id="element-51">
          Empezá a jugar como alguien que{' '}
          <span className="text-brand-pink" data-id="element-52">entiende el partido</span>
        </h1>

        <a href="https://checkout.ebookpoint.shop/cart/59567230648401:1" target="_blank" rel="noopener noreferrer" className="block relative max-w-xl mx-auto my-8 group cursor-pointer" data-id="element-53">
          <div className="absolute inset-0 bg-brand-pink/20 blur-2xl rounded-full group-hover:bg-brand-pink/30 transition-colors duration-500" data-id="element-54"></div>
          <img src="https://cdn.magicpatterns.com/uploads/jV4dPQZ4tPsszb5HCefk6W/ChatGPT_Image_May_26__2026__10_47_35_PM-removebg-preview.png" alt="Fútbol Femenino Elite System" className="relative z-10 w-full h-auto drop-shadow-[0_20px_50px_rgba(0,0,0,0.5)] transition-transform duration-500 group-hover:scale-105" data-id="element-55" />
        </a>

        <h2 className="text-lg md:text-2xl font-medium text-zinc-300 mb-8 max-w-4xl mx-auto text-balance leading-relaxed" data-id="element-56">
          Diseñado para jugadoras que entrenan muchísimo, dejan todo en cada
          práctica, pero sienten que siempre están en el mismo lugar.
        </h2>

        <div className="max-w-2xl mx-auto mb-10 text-sm md:text-base font-semibold" data-id="element-57">
          <div className="flex items-center justify-center gap-3 mb-3 flex-wrap" data-id="element-58">
            <div className="inline-flex items-center gap-1.5 text-yellow-400 bg-yellow-400/10 px-4 py-2 rounded-full" data-id="element-59">
              <Star className="w-5 h-5 fill-current" data-id="element-60" />
              <span data-id="element-61">4.8/5.0</span>
            </div>
            <div className="inline-flex items-center gap-1.5 text-emerald-400 bg-emerald-400/10 px-4 py-2 rounded-full" data-id="element-62">
              <ShieldCheck className="w-5 h-5" data-id="element-63" />
              <span data-id="element-64">Pago Seguro</span>
            </div>
            <div className="inline-flex items-center gap-1.5 text-sky-400 bg-sky-400/10 px-4 py-2 rounded-full" data-id="element-65">
              <BookOpen className="w-5 h-5" data-id="element-66" />
              <span data-id="element-67">+300 páginas</span>
            </div>
          </div>
          <div className="flex justify-center" data-id="element-68">
            <div className="inline-flex items-center gap-1.5 text-brand-pink bg-brand-pink/10 px-4 py-2 rounded-full" data-id="element-69">
              <Zap className="w-5 h-5" data-id="element-70" />
              <span data-id="element-71">PDF Entrega Inmediata</span>
            </div>
          </div>
        </div>

        <Button className="w-full md:w-auto text-lg md:text-xl py-5 px-10" data-id="element-72">
          DOMINÁ TUS PARTIDOS
        </Button>
      </div>
    </section>;
}